// Put your application javascript here
jQuery(document).ready( function() {
	initWrapPageSections();
	initRelatedPosts();
	removeWatermark();
})

function initWrapPageSections() {
	//In case more than 50 blocks are added to a page section, another one will need to be added and layout with the sidebar will be affected
	if(jQuery("main .inner-page-section")) {
		jQuery("main .inner-page-section").wrapAll("<div class='main-page-section'></div>");
	}
}

function initRelatedPosts() {
	jQuery("#relatedblogs .rb_blog-grid").each(function() {
		jQuery(this).find(".rb_title").wrapAll("<div class='rb-inner'></div>");
		jQuery(this).find(".rb-inner").append(jQuery(this).find(".rb_contents"));
		jQuery(this).find(".rb-inner").append(jQuery(this).find(".rb_continue_button"));
		
		jQuery(this).find(".rb_continue_button").removeClass("rb_continue_button");
	})
}

function removeWatermark() {
	
	if (jQuery(".product-card .image-container  img[src*='Fallback']")) {
		jQuery(".product-card .image-container  img[src*='Fallback']").each(function() {
			jQuery(this).parent().addClass("no-watermark");
		})
	}
	
	if (jQuery(".main-product-image-container  img[src*='Fallback']")) {
		jQuery(".main-product-image-container img[src*='Fallback']").each(function() {
			jQuery(this).parent().addClass("no-watermark");
		})
	}
	
	
}